import React, { useEffect, useState } from "react";
import { Alert, Box, CircularProgress, Container, Typography } from "@mui/material";
import { auth } from "../../firebase";
import { useNavigate } from "react-router";

const CODE_KEY = "adminImpersonateCode";

// Share one redeem across React StrictMode double-mount so the one-time code is only used once
let inflightLogin = null;

async function redeemImpersonateCode(code) {
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/impersonate/redeem`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "bkst-version": process.env.REACT_APP_VERSION || "",
    },
    body: JSON.stringify({ code }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Failed to redeem login code");
  }
  if (!data.token) {
    throw new Error("Missing login token");
  }
  return data.token;
}

function loginWithImpersonateCode(code) {
  if (!inflightLogin) {
    inflightLogin = redeemImpersonateCode(code)
      .then((token) => auth.signInWithCustomToken(token))
      .finally(() => {
        sessionStorage.removeItem(CODE_KEY);
        inflightLogin = null;
      });
  }
  return inflightLogin;
}

export default function LoginWithCustomToken() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    let code = params.get("code");

    if (code) {
      sessionStorage.setItem(CODE_KEY, code);
      window.history.replaceState(null, "", window.location.pathname);
    } else {
      code = sessionStorage.getItem(CODE_KEY);
    }

    if (!code) {
      setError("Missing login code");
      return;
    }

    let cancelled = false;

    loginWithImpersonateCode(code)
      .then(() => {
        if (!cancelled) {
          navigate("/", { replace: true });
        }
      })
      .catch((err) => {
        console.log("impersonate login failed", err);
        if (!cancelled) {
          setError(err.message || "Login failed. The link may have expired — try again from admin.");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <Container maxWidth="sm">
      <Box mt={10} textAlign="center">
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <>
            <CircularProgress size={32} />
            <Typography variant="body1" color="textSecondary" mt={2}>
              Signing you in…
            </Typography>
          </>
        )}
      </Box>
    </Container>
  );
}
